import React, { useState, useRef } from 'react';
import { ButtonCommon, AnimationCommon } from 'components/common';
import { FileXls, CaretDown } from '@phosphor-icons/react';
import ExcelSubmenu from '../SubMenu/ExcelSubmenu';
import { ExcelDropdownButtonProps, ExcelSubmenuHandlers } from 'types';

const ExcelDropdownButton: React.FC<ExcelDropdownButtonProps> = ({
  onExportTemplate,
  onImport,
  onExport,
  onExportByView,
  onExportByFilter,
  className = '',
  position = 'left',
  disabled = false,
}) => {
  const [isSubmenuVisible, setIsSubmenuVisible] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  const toggleSubmenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsSubmenuVisible(!isSubmenuVisible);
  };

  const closeSubmenu = () => {
    setIsSubmenuVisible(false);
  };

  const handlers: ExcelSubmenuHandlers = {
    onExportTemplate,
    onImport,
    onExport,
    onExportByView,
    onExportByFilter,
  };

  return (
    <div className={`relative ${className}`} ref={buttonRef}>
      <ButtonCommon
        onClick={toggleSubmenu}
        color='outline'
        size='xs'
        radius='rounded'
        disabled={disabled}
        icon={<FileXls size={20} />}
        className={
          'flex items-center gap-1 bg-[var(--textBlack4)] ' + (!isSubmenuVisible && '!border-[var(--textBlack4)]')
        }
      >
        <span>Nhập / Xuất tệp Excel</span>
        <CaretDown size={16} className={`transition-transform duration-300 ${isSubmenuVisible ? 'rotate-180' : ''}`} />
      </ButtonCommon>

      <AnimationCommon
        effect='fadeDown'
        transition='spring'
        duration={0.2}
        isVisible={isSubmenuVisible}
        className={`absolute top-full z-50 ` + (position === 'left' ? 'left-0' : 'right-0')}
        style={{ transformOrigin: 'top center', marginTop: '4px' }}
      >
        <ExcelSubmenu isVisible={isSubmenuVisible} onClose={closeSubmenu} handlers={handlers} />
      </AnimationCommon>
    </div>
  );
};

export default ExcelDropdownButton;
